import React, { useState, useContext, useRef } from "react";
import { GlobalContext } from "../../context/provider";
import createaction from "../../context/action/barcode/createaction";
import Barcode from 'react-barcode';
import './barcodeprint.css'
import getitemaction from "../../context/action/barcode/getitemaction";
import { Print_barcode_page } from "./print_barcode_page";
import { useReactToPrint } from "react-to-print";

const Barcodee = () => {
    const { initState, recaller, setrecaller, initDispatch, clear } = useContext(GlobalContext);
    
    const [barcode, setbarcode] = useState();
    const [name, setname] = useState();
    const [price, setprice] = useState();

    const [error, seterror] = useState(false);
    const [error1, seterror1] = useState();
    const printRef = useRef();
        
    const printFn = useReactToPrint({
      contentRef: printRef,
      documentTitle: "item_code",
      preserveAfterPrint: true,
      print: (printIframe) =>
      new Promise(() => {
          printIframe.style.display = "none";
          printIframe.contentWindow?.print();
      }),
    });

    return (
        <div>
            <div
                style={{
                position: 'absolute',
                left: '-99999px',
                top: 0
                }}
            >
                <Print_barcode_page ref={printRef} name={name} price={price} barcode={barcode} />
            </div>
            <div className="min-h-screen bg-slate-50 p-6 md:p-8">
            {/* Page Header */}
            <div className="flex items-center justify-between mb-8">
                <div>
                <h1 className="text-2xl font-bold text-slate-800">لەیبڵ پرینتەر</h1>
                <p className="text-sm text-slate-400 mt-0.5">پرینت کردنی لەیبڵەکان</p>
                </div>
            </div>

            <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
                    <div className="w-full">
                        <label
                            className={
                                error1
                                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                                : "block text-sm font-medium text-slate-500 mb-1 text-right"
                            }
                            htmlFor="barcode-input"
                        >
                            باڕکۆد
                        </label>
                        <input
                            id="barcode-input"
                            className={
                                error1
                                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            type="number"
                            value={barcode}
                            onChange={(val) => setbarcode(val.target.value)}
                            onFocus={() => seterror1(false)}
                            onKeyDown={(key) => {
                                if (key.key === "Enter") {
                                    getitemaction(barcode)(setname)(setprice);
                                }
                            }}
                        />
                    </div>

                    {/* Item Name Input */}
                    <div className="w-full">
                        <label
                            className={
                                "block text-sm font-medium text-slate-500 mb-1 text-right"
                            }
                            htmlFor="name-input"
                        >
                            ناوی کاڵا
                        </label>
                        <input
                            id="name-input"
                            className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-gray-200"
                            type="text"
                            value={name}
                            disabled={true}
                            onChange={(val) => setname(val.target.value)}
                        />
                    </div>

                    {/* Price Input */}
                    <div className="w-full">
                        <label
                            className="block text-sm font-medium text-slate-500 mb-1 text-right"
                            htmlFor="price-input"
                        >
                            نرخ
                        </label>
                        <input
                            id="price-input"
                            className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-gray-200"
                            type="text"
                            value={price}
                            disabled={true}
                            onChange={(val) => setprice(val.target.value)}
                        />
                    </div>

                    {/* Print Button */}
                    <div className="w-full">
                        <button
                            className="h-10 px-6 bg-zinc-700 hover:bg-zinc-900 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
                            onClick={() => {
                                if (barcode === "" || !barcode) {
                                    seterror1(true);
                                    return false;
                                }
                                printFn();
                                // window.print();
                            }}
                        >
                            پرینت
                        </button>
                    </div>
                </div>
            </div>
            
            {/* Barcode Display Section */}
            {/* {barcode && (
                <div className="mt-8 flex justify-center">
                    <Barcode value={barcode} />
                </div>
            )} */}
            <div className="barcode_show">
              <div className="w-full px-3 mt-[2%] flex justify-center text-sm">
                {name}
              </div>
              <div className="w-full flex justify-center text-sm">
                {price}
              </div>
              <div className="flex mt-[0] justify-center">
                <Barcode
                    value={barcode} 
                    width={1.1} 
                    height={24} 
                    fontSize={12}
                    // displayValue={false}
                />
              </div>
            </div>
            </div>
        </div>
    );
};

export default Barcodee;